import { debitTypeConfig } from '@/common/config/debitTypeConfig.js';
let lineIndexMixins = {
  data() {
    return {};
  },
  methods: {
    checkNeedBindALiPay() {
      let settings = this.$app.GetSettings();
      if (settings.DebitType == debitTypeConfig.zhifubaodaifu) {
        if (settings.enterpriseOpenStatus != 1) {
          this.$app.Confirm('', '请联系您的企业管理员开通“支付宝(单位代付)”', '知道了', '', false);
          return false;
        } else if (settings.personalBindStatus != 1) {
          uni.navigateTo({
            url: '/pages/index2.0/businessCard?type=1',
          });
          return false;
        }
      }

      return true;
    },
  },
};
export default lineIndexMixins;
